import {BrowserRouter, Route, Routes, useRoutes} from "react-router-dom";

// Routes
import MainRoutes from "./main-route";
import React from "react";
import PrivateOutlet from "./private-outlet-sso";
import MainLayout from "layout/main-layout";
import Examination from "pages/Examination/Examination";
import SSOlogin from "pages/LoginSso/SSOlogin";
import Login from "pages/Login/Login";

export default function ThemeRoutes() {
  return useRoutes(MainRoutes);
  {
    /* <Routes>
        <Route path="/login" element={<SSOlogin></SSOlogin>}></Route>
        <Route path="/admin" element={<PrivateOutlet />}>
          <Route path="/admin" element={<MainLayout></MainLayout>}>
            <Route
              path="/admin/tiep-nhan"
              element={<Examination></Examination>}
            ></Route>
          </Route>
        </Route>
      </Routes> */
  }
}
